import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getSections(Redis = false, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      "/sections/getSections",
      reset,
    );
  },
  // Где вызывается: сервер.
  async getSectionMeta(id) {
    const { data } = await axios.get(
      `${config.API_URL}/sections/getSectionMeta?id=${id}`,
    );
    return data;
  },
  // Где вызывается: сервер.
  async getProductById(id, Redis = false, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sections/getProductById?id=${id}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getProductStocksByIds(ids) {
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/sections/getProductStocksByIds?ids=${ids}`,
    );
    return data;
  },
  /**
   * Где вызывается: сервер.
   * Подписи для фильтра: product_props (code → name) и product_prop_values (code → name).
   * Кеш: Redis hash Api_sections / поле props (redisGetHandler).
   */
  async getProps(Redis = false, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sections/props`,
      reset,
    );
  },
});
